/**
 * sidebarPref.ts — the sidebar's remembered Tools state (Sidebar v2 slice S1,
 * RULED 2026-10-10): the spec's "Tools ▾" caption keeps its open state, kept
 * DEVICE-LOCAL in browser storage through draftStorage's guard and keyed per
 * tenant and user — the shortcutsPref.ts shape. Default OPEN. With no /v1/me
 * identity yet the key is null: open, and nothing is written. Storage that
 * throws or holds anything but `false` reads as open.
 */
import { readDraft, writeDraft } from './draftStorage'

export function sidebarToolsPrefKey(identity: { tenantId: string; subject: string } | null): string | null {
  return identity ? `gss.pref.sidebarToolsOpen.${identity.tenantId}.${identity.subject}` : null
}

export function readToolsOpen(key: string | null): boolean {
  if (!key) return true
  return readDraft<unknown>(key) !== false
}

export function writeToolsOpen(key: string | null, open: boolean): void {
  if (key) writeDraft(key, open)
}
